export default __webpack_public_path__ + "static/media/wellness_logo.57d02373.png";